import React, { Component } from 'react'
import { withStyles, Grid, Card, CardHeader, Avatar, Typography, CardContent, Divider } from '@material-ui/core';
import CreditCard from '@material-ui/icons/CreditCard'
import { PostData, GetData, PutData, DeleteData } from '../../../api/service';
import { Alert, Space } from 'antd';
const styles = theme => ({

})


class CertificateDashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            isLoading: true,
            status: false,
            message: '',
            table_data: [],
            sub_table:[],
            edit: false,
            edit_data: [],
            is_all_loaded: false
        }

    }

    
    render() {
        let { classes } = this.props;
        return (
            <div>
                <Alert
      message="Certificate Generation"
      description="Here you can generate certificate of various types.First insert the certificate types."
      type="info"
      showIcon
    />
              
            </div>
        )
    }
}

export default withStyles(styles)(CertificateDashboard)